<template>
  <SmartLink
    :url="route.url"
    :target="route.target"
    :route="route.route"
    :method="route.method"
    :event="route.event"
    :class="clsx('main-menu-button main-menu-button--with-submenu', {
      'main-menu-button__active': isHovered || isActivePage || isTouched }
    )"
    @click="handleClick"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @touchstart.passive="handleTouchStart"
    @touchend="handleTouchEnd"
    @touchcancel="handleTouchCancel"
  >
    <div class="main-menu-button__content">
      <div class="main-menu-icon mr-2">
        <component
          :is="route.icon"
          :color="isHovered || isActivePage || isTouched ? '#0A77FF' : '#78829D'"
        />
      </div>
      {{ route.name }}

      <OpenDownIcon
        :class="clsx('main-menu-open-icon', { 'main-menu-open-icon__active': isActive })"
        :color="isHovered || isTouched ? '#0A77FF' : '#09090B'"
      />
    </div>

    <div :class="clsx('submenu-list-wrapper', { 'submenu-list-wrapper__active': isActive })">
      <MobileMenuList :items="subitems" class="submenu-list" />
    </div>
  </SmartLink>
</template>

<script>
import clsx from 'clsx';
import { mapGetters } from 'vuex';
import MobileMenuList from './mobile-menu-list';
import { OpenDownIcon } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    route: {
      type: Object,
      default: null,
      required: true,
    },
    subitems: {
      type: Array,
      default: () => [],
      required: false,
    },
    activeGroup: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isActive: false,
      isHovered: false,
      isTouched: false,
      submenuTop: 0,
      submenuLeft: 0,
      touchStartTime: 0
    };
  },
  components: { MobileMenuList, SmartLink, OpenDownIcon },
  computed: {
    ...mapGetters('currentPageModule', ['getActivePage']),
    isActivePage() {
      return this.route?.page && this.route?.page === this.getActivePage;
    },
  },
  methods: {
    clsx,
    handleClick() {
      this.isActive = !this.isActive;
      this.$emit('change-active-group', this.isActive ? this.route?.group || '' : '');
    },
    handleMouseEnter() {
      this.isHovered = true;
    },
    handleMouseLeave() {
      this.isHovered = false;
    },
    handleTouchStart() {
      this.touchStartTime = Date.now();
    },
    handleTouchEnd() {
      const isQuickTap = (Date.now() - this.touchStartTime) < 300;
      if (this.subitems.length && isQuickTap) {
        this.isTouched = !this.isTouched;
        this.isActive = !this.isActive;
        this.$emit('change-active-group', this.isActive ? this.route?.group || '' : '');
      }
    },
    handleTouchCancel() {
      this.isTouched = false;
    },
  },
  watch: {
    activeGroup: {
      immediate: true,
      handler(newVal) {
        if (newVal !== this.route?.group) {
          this.isHovered = false;
          this.isTouched = false;
          this.isActive = false;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.main-menu-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid #F3F4F6;
  font-size: 14px;
  font-weight: 500;

  &__active {
    color: #0A77FF;
  }

  &__content {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
}

.submenu-list-wrapper {
  display: none;

  &__active {
    display: block;
  }
}

.main-menu-open-icon {
  margin-left: auto;
  transform: rotate(-90deg);
  transition: transform 0.3s ease;

  &__active {
    transform: rotate(0deg);
  }
}
</style>
